<vw-toast-popup
  [isOpen]="isOpen"
  width="100%"
  borderRadius="20px"
  customClass="bg-white"
  (close)="onClose()"
>
  <div class="px-4 py-2">
    <h2 class="text-2xl text-[#062825] font-semibold pb-1">
      {{ 'profile.notification-preferences.title' | translate }}
    </h2>
    <p class="text-sm text-[#9BA6A1] pb-4">
      {{ 'profile.notification-preferences.description' | translate }}
    </p>

    @if (loading) {
    <div class="py-8 text-center text-[#9BA6A1] text-sm">
      {{ 'profile.notification-preferences.loading' | translate }}
    </div>
    } @else {
    <div class="flex flex-col gap-3">
      @for (p of preferences; track p.category) {
      <div class="rounded-2xl border border-gray-100 bg-[#FBFCFB] px-3 py-3">
        <!-- En-tete : nom de la categorie, bouton d'aide, interrupteur maitre -->
        <div class="flex items-center gap-2">
          <span class="flex-1 min-w-0 text-base text-primary-dark font-semibold">
            {{
              'profile.notification-preferences.categories.' + p.category
                | translate
            }}
          </span>

          <button
            type="button"
            class="flex h-6 w-6 shrink-0 items-center justify-center rounded-full border text-xs font-semibold transition-colors"
            [class]="
              expanded === p.category
                ? 'border-primary bg-primary text-white'
                : 'border-gray-300 text-[#9BA6A1]'
            "
            [attr.aria-expanded]="expanded === p.category"
            [attr.aria-label]="
              'profile.notification-preferences.what-is-it' | translate
            "
            (click)="toggleInfo(p.category)"
          >
            i
          </button>

          <label class="relative inline-flex shrink-0 items-center cursor-pointer">
            <input
              type="checkbox"
              [(ngModel)]="p.isEnabled"
              class="sr-only peer"
            />
            <div
              class="w-11 h-6 bg-gray-300 rounded-full peer peer-checked:bg-primary transition-colors after:content-[''] after:absolute after:top-0.5 after:left-0.5 after:bg-white after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:after:translate-x-5"
            ></div>
          </label>
        </div>

        <!-- Aide : a quoi ressemble concretement une alerte de ce type -->
        @if (expanded === p.category) {
        <div class="mt-2 rounded-xl bg-white px-3 py-2 border border-gray-100">
          <p class="text-xs text-[#617069] leading-relaxed">
            {{
              'profile.notification-preferences.help.' + p.category + '.what'
                | translate
            }}
          </p>
          <p class="mt-1.5 text-xs text-[#9BA6A1] italic leading-relaxed">
            {{
              'profile.notification-preferences.help.' + p.category + '.example'
                | translate
            }}
          </p>
        </div>
        }

        <!-- Reglages fins : une ligne par reglage, libelle a gauche, controle a
             droite. Les empiler evite que les libelles se chevauchent sur les
             petits ecrans, ce qui arrivait quand tout tenait sur une ligne. -->
        <div
          class="mt-3 flex flex-col gap-2.5"
          [class.opacity-40]="!p.isEnabled"
          [class.pointer-events-none]="!p.isEnabled"
        >
          <div class="flex items-center justify-between gap-3">
            <span class="text-sm text-primary-dark">
              {{ 'profile.notification-preferences.push-enabled' | translate }}
            </span>
            <label class="relative inline-flex shrink-0 items-center cursor-pointer">
              <input
                type="checkbox"
                [(ngModel)]="p.pushEnabled"
                [disabled]="!p.isEnabled"
                class="sr-only peer"
              />
              <div
                class="w-11 h-6 bg-gray-300 rounded-full peer peer-checked:bg-primary transition-colors after:content-[''] after:absolute after:top-0.5 after:left-0.5 after:bg-white after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:after:translate-x-5"
              ></div>
            </label>
          </div>

          <div class="flex items-center justify-between gap-3">
            <span class="text-sm text-primary-dark">
              {{ 'profile.notification-preferences.min-severity' | translate }}
            </span>
            <select
              [(ngModel)]="p.minPushSeverity"
              [disabled]="!p.isEnabled || !p.pushEnabled"
              class="w-40 shrink-0 text-sm text-primary-dark bg-white border border-gray-200 rounded-lg px-2 py-1.5"
            >
              @for (s of severityOptions; track s.value) {
              <option [ngValue]="s.value">{{ s.label | translate }}</option>
              }
            </select>
          </div>
        </div>
      </div>
      }
    </div>

    <!-- Le digest quotidien n'est pas une categorie : le rappeler evite de
         chercher un reglage qui n'existe pas. -->
    <p class="mt-4 text-xs text-[#9BA6A1] leading-relaxed">
      {{ 'profile.notification-preferences.footnote' | translate }}
    </p>

    <div class="mt-4">
      <vw-button
        [label]="'profile.notification-preferences.save' | translate"
        look="primary"
        [loading]="saving"
        (onClick)="save()"
        customClass="w-full"
      ></vw-button>
    </div>
    }
  </div>
</vw-toast-popup>
